<template>
  <div>
    <v-dialog v-model="dialog">
      <v-row justify="center">
        <v-card>
          <v-card-title>
            <span class="text-h5">Fizička osoba</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="UID/OIB*"
                    v-model="fizicka_osoba.oib"
                    hint="Ukoliko osobi ne znate oib automatski će se zapisati jedinstveni identifikator"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Ime*"
                    required
                    v-model="fizicka_osoba.ime"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Prezime*"
                    required
                    v-model="fizicka_osoba.prezime"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Email*"
                    v-model="fizicka_osoba.email"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Broj telefona*"
                    v-model="fizicka_osoba.broj_telefona"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    name="opis"
                    label="Opis"
                    v-model="fizicka_osoba.opis"
                    hint="Unesite opis osobe"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Adresa*"
                    v-model="fizicka_osoba.adresa.adresa"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Poštanski broj*"
                    required
                    v-model="fizicka_osoba.adresa.post_br"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Grad*"
                    v-model="fizicka_osoba.adresa.grad"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*obavezna polja</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text> Odustani </v-btn>
            <v-btn color="blue darken-1" text @click="obradiPromjene()">
              Pohrani
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-dialog>
  </div>
</template>

<script>
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
export default {
  name: "pers_data",
  props: {
    fizicka_osoba: {
        type: Object,
        required: false,
        default: {
          ime: "",
          prezime: "",
          broj_telefona:"",
          oib: Date.now(),
          email: "",
          opis: "",
          adresa: {
            adresa: "",
            post_br: "",
            grad: "",
          },
        },
    },
    isNew: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },

  methods: {
    obradiPromjene() {
      console.log("Tu je ");
      console.log(this.isNew);
      if (this.isNew) {
        this.createOsoba();
      } else {
        this.updateOsoba();
      }
    },
    createOsoba() {
      //if prolazi provjeru
      //Poziv na api koji kreira osobu
      osobe.insertFizicka(this.fizicka_osoba);
    },

    updateOsoba() {
      osobe.updateFizicka(this.fizicka_osoba, this.fizicka_osoba.oib);
      //if prolazi provjeru
      //Poziv na api koji ažurira osobu
    },
  },
};
</script>

<style>
</style>